"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CompleteMultipartUploadInput_1 = require("./CompleteMultipartUploadInput");
var CompleteMultipartUploadOutput_1 = require("./CompleteMultipartUploadOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.CompleteMultipartUpload = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "CompleteMultipartUpload",
    http: {
        method: "POST",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: CompleteMultipartUploadInput_1.CompleteMultipartUploadInput
    },
    output: {
        shape: CompleteMultipartUploadOutput_1.CompleteMultipartUploadOutput
    },
    errors: []
};
//# sourceMappingURL=CompleteMultipartUpload.js.map